var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "d2-container",
    [
      _c(
        "el-row",
        { attrs: { gutter: 20 } },
        [
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c(
                "el-select",
                {
                  staticClass: "flex-1",
                  attrs: {
                    filterable: "",
                    placeholder: _vm.$t("pleaseChoose")
                  },
                  on: { change: _vm.envIdChange },
                  model: {
                    value: _vm.paramsData.env_id,
                    callback: function($$v) {
                      _vm.$set(_vm.paramsData, "env_id", $$v)
                    },
                    expression: "paramsData.env_id"
                  }
                },
                _vm._l(_vm.szgmEnv, function(item) {
                  return _c("el-option", {
                    key: item.label,
                    attrs: { label: item.label, value: item.id }
                  })
                }),
                1
              )
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c(
                "el-select",
                {
                  attrs: {
                    filterable: "",
                    placeholder: _vm.$t("serverChannel")
                  },
                  on: { change: _vm.serverChange },
                  model: {
                    value: _vm.server_channel,
                    callback: function($$v) {
                      _vm.server_channel = $$v
                    },
                    expression: "server_channel"
                  }
                },
                _vm._l(_vm.serverChannel, function(item) {
                  return _c("el-option", {
                    key: item.value,
                    attrs: { label: item.label, value: item.value }
                  })
                }),
                1
              )
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c(
                "el-select",
                {
                  attrs: {
                    clearable: "",
                    filterable: "",
                    placeholder: _vm.$t("showTestServer")
                  },
                  on: { change: _vm.serverChannelChange },
                  model: {
                    value: _vm.show_test,
                    callback: function($$v) {
                      _vm.show_test = $$v
                    },
                    expression: "show_test"
                  }
                },
                _vm._l(_vm.serverType, function(item) {
                  return _c("el-option", {
                    key: item.value,
                    attrs: { label: item.label, value: item.value }
                  })
                }),
                1
              )
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c(
                "el-select",
                {
                  attrs: {
                    multiple: "",
                    "collapse-tags": "",
                    filterable: "",
                    placeholder: _vm.$t("server")
                  },
                  on: { change: _vm.severChange },
                  model: {
                    value: _vm.paramsData.server_id,
                    callback: function($$v) {
                      _vm.$set(_vm.paramsData, "server_id", $$v)
                    },
                    expression: "paramsData.server_id"
                  }
                },
                [
                  _c(
                    "el-checkbox",
                    {
                      on: { change: _vm.selectAll },
                      model: {
                        value: _vm.checked,
                        callback: function($$v) {
                          _vm.checked = $$v
                        },
                        expression: "checked"
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("selectAll")))]
                  ),
                  _vm._l(_vm.serverListYJ, function(item) {
                    return _c("el-option", {
                      key: item.serverID,
                      attrs: { label: item.serverName, value: item.serverID }
                    })
                  })
                ],
                2
              )
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c(
                "el-select",
                {
                  attrs: {
                    clearable: "",
                    filterable: "",
                    placeholder: _vm.$t("emailType")
                  },
                  model: {
                    value: _vm.paramsData.email_type,
                    callback: function($$v) {
                      _vm.$set(_vm.paramsData, "email_type", $$v)
                    },
                    expression: "paramsData.email_type"
                  }
                },
                _vm._l(_vm.emailType, function(item) {
                  return _c("el-option", {
                    key: item.value,
                    attrs: { label: item.label, value: item.value }
                  })
                }),
                1
              )
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c(
                "el-select",
                {
                  attrs: {
                    clearable: "",
                    filterable: "",
                    placeholder: _vm.$t("language")
                  },
                  model: {
                    value: _vm.paramsData.language,
                    callback: function($$v) {
                      _vm.$set(_vm.paramsData, "language", $$v)
                    },
                    expression: "paramsData.language"
                  }
                },
                _vm._l(_vm.Language, function(item) {
                  return _c("el-option", {
                    key: item.label,
                    attrs: { label: item.label, value: item.value }
                  })
                }),
                1
              )
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c("el-input", {
                attrs: { placeholder: _vm.$t("title"), clearable: "" },
                model: {
                  value: _vm.paramsData.title,
                  callback: function($$v) {
                    _vm.$set(_vm.paramsData, "title", $$v)
                  },
                  expression: "paramsData.title"
                }
              })
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c("el-input", {
                attrs: { placeholder: _vm.$t("content"), clearable: "" },
                model: {
                  value: _vm.paramsData.content,
                  callback: function($$v) {
                    _vm.$set(_vm.paramsData, "content", $$v)
                  },
                  expression: "paramsData.content"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-row",
        [
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function() {
                      _vm.serverJud().then(function() {
                        _vm.$refs.draft.open({}, null, true)
                      })
                    }
                  }
                },
                [_vm._v(" " + _vm._s(_vm.$t("addEmail")) + " ")]
              )
            ],
            1
          ),
          _c(
            "el-col",
            { staticClass: "operationBut", attrs: { span: 4 } },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.reqLoading },
                  on: {
                    click: function($event) {
                      return _vm.getList(1)
                    }
                  }
                },
                [_vm._v(" " + _vm._s(_vm.$t("search")) + " ")]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.reqLoading,
              expression: "reqLoading"
            }
          ],
          attrs: { data: _vm.tableData, border: "" }
        },
        [
          _c("el-table-column", {
            attrs: { prop: "id", label: _vm.$t("id"), "min-width": "80" }
          }),
          _c("el-table-column", {
            attrs: {
              prop: "sender",
              label: _vm.$t("sender"),
              "min-width": "100"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var row = ref.row
                  return [
                    _c("div", { staticClass: "text-ellipsis-1" }, [
                      _vm._v(_vm._s(row.sender))
                    ])
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: {
              prop: "title",
              label: _vm.$t("emailTitle"),
              "min-width": "180",
              "show-overflow-tooltip": ""
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var row = ref.row
                  return [
                    _c("div", { staticClass: "text-ellipsis-1" }, [
                      _vm._v(_vm._s(row.title))
                    ])
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: {
              prop: "email_type",
              label: _vm.$t("emailType"),
              "min-width": "120"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var row = ref.row
                  return [
                    row.state == 2
                      ? _c("div", [
                          _vm._v(_vm._s(_vm.$t("normalAnnouncement")))
                        ])
                      : _vm._e(),
                    row.state == 1
                      ? _c("div", [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.emailType.find(function(item) {
                                  return item.value == row.email_type
                                }).label
                              ) +
                              " "
                          )
                        ])
                      : _vm._e()
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: {
              prop: "reward",
              label: _vm.$t("mailAttachment"),
              "min-width": "100"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var row = ref.row
                  return [
                    _c(
                      "div",
                      {
                        staticStyle: { color: "#409EFF", cursor: "pointer" },
                        on: {
                          click: function($event) {
                            return _vm.$refs.viewArticles.init(row.reward)
                          }
                        }
                      },
                      [_vm._v(" " + _vm._s(_vm.$t("view")) + " ")]
                    )
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: {
              prop: "language",
              label: _vm.$t("language"),
              "min-width": "100"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var row = ref.row
                  return [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.Language.filter(function(item) {
                            return item.value == row.language
                          })[0].label
                        ) +
                        " "
                    )
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: {
              prop: "server_id",
              label: _vm.$t("serverId"),
              "min-width": "160",
              "show-overflow-tooltip": ""
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var row = ref.row
                  return [
                    _c(
                      "div",
                      {
                        staticClass: "text-ellipsis-1",
                        staticStyle: { width: "140px" }
                      },
                      [_vm._v(_vm._s(row.server_id))]
                    )
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: {
              prop: "email_user_ids",
              label: _vm.$t("targetAccount"),
              "min-width": "160",
              "show-overflow-tooltip": ""
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var row = ref.row
                  return [
                    _c(
                      "div",
                      {
                        staticClass: "text-ellipsis-1",
                        staticStyle: { width: "140px" }
                      },
                      [_vm._v(_vm._s(row.email_user_ids))]
                    )
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: {
              prop: "times",
              label: _vm.$t("generatedAccountTimeRange"),
              "min-width": "220"
            }
          }),
          _c("el-table-column", {
            attrs: {
              prop: "created_at",
              label: _vm.$t("addTime"),
              "min-width": "180"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var row = ref.row
                  return [
                    _vm._v(
                      " " + _vm._s(_vm.$times.formDate(row.created_at)) + " "
                    )
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: {
              prop: "expire",
              label: _vm.$t("expireTime"),
              "min-width": "180"
            }
          }),
          _c("el-table-column", {
            attrs: { prop: "expire", label: _vm.$t("details") },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var row = ref.row
                  return [
                    _c(
                      "div",
                      {
                        staticStyle: { color: "#409EFF", cursor: "pointer" },
                        on: {
                          click: function($event) {
                            return _vm.$refs.emailDetils.init(row)
                          }
                        }
                      },
                      [_vm._v(" " + _vm._s(_vm.$t("details")) + " ")]
                    )
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: {
              prop: "delay_state",
              label: _vm.$t("mailStatus"),
              "min-width": "250"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var row = ref.row
                  return [
                    row.state == 2 && row.delay_state == 2
                      ? _c("div", [_vm._v(_vm._s(_vm.$t("normalTaskNotSent")))])
                      : _vm._e(),
                    row.state == 2 && row.delay_state == 1
                      ? _c("div", [
                          _vm._v(
                            " " +
                              _vm._s(_vm.$t("scheduledSend")) +
                              " " +
                              _vm._s(row.delay_time) +
                              " "
                          )
                        ])
                      : _vm._e(),
                    (row.state == 1 && row.delay_state == 1) ||
                    (row.state == 1 && row.delay_state == 2)
                      ? _c("div", [
                          _vm._v(
                            " " +
                              _vm._s(_vm.$t("sent")) +
                              " " +
                              _vm._s(row.send_time) +
                              " "
                          )
                        ])
                      : _vm._e()
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("operation"),
              width: "320",
              fixed: "right",
              align: "center"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var row = ref.row
                  return [
                    _c("div", { staticClass: "x-c" }, [
                      _c(
                        "div",
                        {
                          staticClass: "controlsBtn",
                          on: {
                            click: function($event) {
                              return _vm.regeneration(row)
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("regenerate")))]
                      ),
                      row.email_state != 5
                        ? _c("div", { staticClass: "controlsBtn-vertical" })
                        : _vm._e()
                    ]),
                    row.email_state == 1 || row.email_state == 3
                      ? _c("div", [
                          _c("div", { staticClass: "x-c" }, [
                            (row.state == 2 && row.delay_state == 2) ||
                            (row.state == 2 && row.delay_state == 1)
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "controlsBtn",
                                    on: {
                                      click: function($event) {
                                        return _vm.$refs.draft.open(
                                          row,
                                          null,
                                          true
                                        )
                                      }
                                    }
                                  },
                                  [_vm._v(" " + _vm._s(_vm.$t("modify")) + " ")]
                                )
                              : _vm._e(),
                            (row.state == 2 && row.delay_state == 2) ||
                            (row.state == 2 && row.delay_state == 1)
                              ? _c("div", {
                                  staticClass: "controlsBtn-vertical"
                                })
                              : _vm._e(),
                            row.state == 2 && row.delay_state == 2
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "controlsBtn",
                                    on: {
                                      click: function($event) {
                                        return _vm.$refs.addEmail.open(
                                          row,
                                          _vm.serverChannel,
                                          true
                                        )
                                      }
                                    }
                                  },
                                  [_vm._v(" " + _vm._s(_vm.$t("send")) + " ")]
                                )
                              : _vm._e(),
                            row.state == 2 && row.delay_state == 2
                              ? _c("div", {
                                  staticClass: "controlsBtn-vertical"
                                })
                              : _vm._e(),
                            _c(
                              "div",
                              {
                                staticClass: "controlsBtn",
                                on: {
                                  click: function($event) {
                                    return _vm.deleHandle(row.id)
                                  }
                                }
                              },
                              [_vm._v(_vm._s(_vm.$t("delete")))]
                            )
                          ])
                        ])
                      : _vm._e(),
                    row.email_state == 2
                      ? _c(
                          "div",
                          { staticClass: "x-c" },
                          [
                            (row.state == 2 && row.delay_state == 2) ||
                            (row.state == 2 && row.delay_state == 1)
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "controlsBtn",
                                    on: {
                                      click: function($event) {
                                        return _vm.$refs.draft.open(
                                          row,
                                          null,
                                          true
                                        )
                                      }
                                    }
                                  },
                                  [_vm._v(" " + _vm._s(_vm.$t("modify")) + " ")]
                                )
                              : _vm._e(),
                            (row.state == 2 && row.delay_state == 2) ||
                            (row.state == 2 && row.delay_state == 1)
                              ? _c("div", {
                                  staticClass: "controlsBtn-vertical"
                                })
                              : _vm._e(),
                            row.state == 2 && row.delay_state == 2
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "controlsBtn",
                                    on: {
                                      click: function($event) {
                                        return _vm.$refs.addEmail.open(
                                          row,
                                          _vm.serverChannel,
                                          true
                                        )
                                      }
                                    }
                                  },
                                  [_vm._v(" " + _vm._s(_vm.$t("send")) + " ")]
                                )
                              : _vm._e(),
                            row.state == 2 && row.delay_state == 2
                              ? _c("div", {
                                  staticClass: "controlsBtn-vertical"
                                })
                              : _vm._e(),
                            _c(
                              "div",
                              {
                                staticClass: "controlsBtn",
                                on: {
                                  click: function($event) {
                                    return _vm.deleHandle(row.id)
                                  }
                                }
                              },
                              [_vm._v(_vm._s(_vm.$t("delete")))]
                            ),
                            row.state != 1
                              ? _c("div", {
                                  staticClass: "controlsBtn-vertical"
                                })
                              : _vm._e(),
                            row.state != 1
                              ? _c(
                                  "el-popconfirm",
                                  {
                                    attrs: {
                                      title: _vm.$t("operation"),
                                      "confirm-button-text": _vm.$t("approved"),
                                      "cancel-button-type": "warning",
                                      disabled: row.check_state == 1
                                    },
                                    on: {
                                      confirm: function($event) {
                                        return _vm.audit(row, 1)
                                      }
                                    }
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "controlsBtn",
                                        attrs: { slot: "reference" },
                                        slot: "reference"
                                      },
                                      [
                                        row.check_state == 1
                                          ? _c("p", [
                                              _vm._v(_vm._s(_vm.$t("passed")))
                                            ])
                                          : _vm._e(),
                                        row.check_state == 2
                                          ? _c(
                                              "p",
                                              { staticClass: "color666" },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t("pendingReviewWait")
                                                  )
                                                )
                                              ]
                                            )
                                          : _vm._e()
                                      ]
                                    )
                                  ]
                                )
                              : _vm._e()
                          ],
                          1
                        )
                      : _vm._e(),
                    row.email_state == 4
                      ? _c("div", { staticClass: "x-c" }, [
                          row.state == 2 &&
                          row.delay_state == 2 &&
                          row.check_state == 1
                            ? _c(
                                "div",
                                {
                                  staticClass: "controlsBtn",
                                  on: {
                                    click: function($event) {
                                      return _vm.$refs.addEmail.open(
                                        row,
                                        _vm.serverChannel,
                                        true
                                      )
                                    }
                                  }
                                },
                                [_vm._v(" " + _vm._s(_vm.$t("send")) + " ")]
                              )
                            : _vm._e(),
                          row.state == 2 &&
                          row.delay_state == 2 &&
                          row.check_state == 1
                            ? _c("div", { staticClass: "controlsBtn-vertical" })
                            : _vm._e(),
                          _c(
                            "div",
                            {
                              staticClass: "controlsBtn",
                              on: {
                                click: function($event) {
                                  return _vm.deleHandle(row.id)
                                }
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("delete")))]
                          ),
                          row.check_state == 2 && row.state != 1
                            ? _c("div", { staticClass: "controlsBtn-vertical" })
                            : _vm._e(),
                          row.check_state == 2 && row.state != 1
                            ? _c("div", { staticClass: "color666" }, [
                                _vm._v(
                                  " " + _vm._s(_vm.$t("underReviewing")) + " "
                                )
                              ])
                            : _vm._e()
                        ])
                      : _vm._e()
                  ]
                }
              }
            ])
          })
        ],
        1
      ),
      _c("el-pagination", {
        attrs: {
          layout: "total,sizes, prev, pager, next",
          "current-page": _vm.paramsData.page,
          total: _vm.total
        },
        on: { "current-change": _vm.currentChaneg }
      }),
      _c("addEmail", {
        ref: "addEmail",
        attrs: {
          propsData: {
            server_id: _vm.paramsData.server_id,
            env_id: _vm.paramsData.env_id
          }
        },
        on: {
          change: function($event) {
            return _vm.getList(_vm.paramsData.page)
          }
        }
      }),
      _c("draft", {
        ref: "draft",
        attrs: {
          propsData: {
            server_id: _vm.paramsData.server_id,
            env_id: _vm.paramsData.env_id
          }
        },
        on: {
          change: function($event) {
            return _vm.getList(_vm.paramsData.page)
          }
        }
      }),
      _c("viewArticles", { ref: "viewArticles" }),
      _c("emailDetils", { ref: "emailDetils" })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }